import { useEffect, useState } from "react";

const LANDSCAPE_QUERY = "(orientation: landscape)";

// Screen orientation, not physical tilt: browsers orient camera frames to the
// screen, so this is what decides whether a captured frame comes out landscape.
// screen.orientation first — matchMedia also flips for split-screen/keyboards.
const readIsLandscape = () => {
  const type = window.screen?.orientation?.type;
  return type ? type.startsWith("landscape") : window.matchMedia(LANDSCAPE_QUERY).matches;
};

export const useOrientation = () => {
  const [isLandscape, setIsLandscape] = useState(readIsLandscape);

  useEffect(() => {
    const update = () => setIsLandscape(readIsLandscape());
    const mql = window.matchMedia(LANDSCAPE_QUERY);
    const screenOrientation = window.screen?.orientation;
    // Safari < 14 only supports addListener/removeListener.
    mql.addEventListener ? mql.addEventListener("change", update) : mql.addListener(update);
    screenOrientation?.addEventListener?.("change", update);
    update();
    return () => {
      mql.removeEventListener ? mql.removeEventListener("change", update) : mql.removeListener(update);
      screenOrientation?.removeEventListener?.("change", update);
    };
  }, []);

  return isLandscape;
};

export default useOrientation;
